import { useNavigate } from 'react-router-dom';
import queryString, { StringifiableRecord } from 'query-string';

export const useChangeQueryParams = (page: string) => {
  const navigate = useNavigate();

  return (params: StringifiableRecord | string) => {
    const paramsStr = typeof params === 'string' ? params : queryString.stringify(params);
    navigate(`/${page}?${paramsStr}`, { replace: true });
  };
};
